import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-furniture-fabrics-color',
  templateUrl: './furniture-fabrics-color.component.html',
  styleUrls: ['./furniture-fabrics-color.component.css']
})
export class FurnitureFabricsColorComponent implements OnInit {
    furnitureFabricsId;

    furnitureFabricsColorId;

    public edit?: Edit;

    public selectListLights: LightItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.furnitureFabricsId = this.stateService.getStateParams()['furniturefabrics_id'];
        this.furnitureFabricsColorId = this.stateService.getStateParams()['furniturefabricscolor_id'];
    }

    private async loadEdit() {
        if (!!this.furnitureFabricsId && !!this.furnitureFabricsColorId) {
            this.edit = (await this.datatask.Post(2120, {
                furniturefabrics_id: this.furnitureFabricsId,
                furniturefabricscolor_id: this.furnitureFabricsColorId
            }))[0];
        }
    }

    private async loadFurnitureFabricsLights(): Promise<void> {
        this.selectListLights = await this.datatask.Post(2121);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2122, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadFurnitureFabricsLights();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    furniturefabricscolor_id: string;
    furniturefabricscolor_name: string;
    furniturefabrics_id: string;
    furniturefabrics_name: string;
    suppliers_prod_no: string;
    prod_id: string;
    prod_name: string;
    furniturefabrics_light_no: string;
    isnew: string;
}

interface LightItem {
    furniturefabrics_light_no: number;
    light_name: number;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('furnitureFabricsColor', {
//        templateUrl: 'views/components/views/furnitureFabricsColor/furnitureFabricsColor.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'furnitureFabricsColorService', function ($stateParams, stateService, modalService, translateService, furnitureFabricsColorService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let furnitureFabricsId = $stateParams.furniturefabrics_id;
//            let furnitureFabricsColorId = $stateParams.furniturefabricscolor_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListLights: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await furnitureFabricsColorService.getEdit({
//                    furniturefabrics_id: furnitureFabricsId,
//                    furniturefabricscolor_id: furnitureFabricsColorId
//                }))[0];
//            }

//            async function loadFurnitureFabricsLights() {
//                vm.model.selectListLights = await furnitureFabricsColorService.listFurnitureFabricsLights();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                furnitureFabricsColorService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadFurnitureFabricsLights();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
